import BaseEntityDto from "src/app/common/dtos/BaseEntityDto";

/**
 * Test User DTO
 */

export default class QAUsersDTO extends BaseEntityDto
{
    identifier: string;

    internalIdentifier: string;
}